import React, { useEffect, useState, useCallback } from "react";
import ReactPaginate from "react-paginate";
import api from "../../axiosConfig";
import {
  Table,
  Button,
  InputGroup,
  FormControl,
  Container,
  Col,
  Badge,
} from "react-bootstrap";
import { useNavigate, useSearchParams } from "react-router-dom";
import "../pagination.css";
import WooPublishToolbar from "./WooPublishToolbar";
import {useAuth} from "../auth/AuthContext";

function BxpartList() {
  const navigate = useNavigate();
  const {user}=useAuth();
  const [woo,setWoo]=useState(null),[selected,setSelected]=useState([]);
  useEffect(()=>{let alive=true;setWoo(null);setSelected([]);api.get('/woocommerce/config').then(r=>{if(alive)setWoo(r.data);}).catch(()=>{});return()=>{alive=false;};},[user]);
  const selectable=!!woo?.can_publish;
  const toggle=id=>setSelected(prev=>prev.includes(id)?prev.filter(x=>x!==id):prev.length<50?[...prev,id]:prev);

  const [items, setItems] = useState([]);
  const [totalCount, setTotalCount] = useState(0);

  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [searchParams, setSearchParams] = useSearchParams();
  const search = searchParams.get("q") || "";

  // Căutare + paginare sincronizate cu backend-ul
  const fetchItems = useCallback(async () => {
    const skip = currentPage * itemsPerPage;
    try {
      const res = await api.get("/bxpart/", {
        params: {
          search,
          skip,
          limit: itemsPerPage,
        },
      });
      setItems(res.data.items);
      setSelected([]);
      setTotalCount(res.data.total);
      // console.log("🧾 Răspuns complet:", res);
      console.log("📦 Date din res.data:", res.data);
    } catch (err) {
      console.error("Eroare la încărcare:", err);
    }
  }, [search, currentPage, itemsPerPage]);

  useEffect(() => {
    fetchItems();
  }, [fetchItems]);

  const handleSearchChange = (e) => {
    setSearchParams({ q: e.target.value });
    setCurrentPage(0); // reset pagină când cauți
  };

  const handleDelete = async (id) => {
    if (
      window.confirm("Sigur dorești să ștergi înregistrarea cu ID " + id + "?")
    ) {
      try {
        await api.delete(`/bxpart/${id}`);
        fetchItems(); // reîncărcăm lista după ștergere
      } catch (err) {
        alert(err.response?.data?.detail || "Eroare la ștergere.");
      }
    }
  };
  const TipGrupaBadge = ({ v }) => {
    const map = {
      1: { text: "Servicii primite", variant: "info" },
      2: { text: "Marfă / Stoc", variant: "success" },
      3: { text: "Servicii prestate", variant: "warning" },
    };
    const x = map[v] || { text: v ?? "—", variant: "secondary" };
    return <Badge bg={x.variant}>{x.text}</Badge>;
  };

  const pageCount = Math.max(1, Math.ceil(totalCount / itemsPerPage));

  return (
    <Container className="mt-4">
      <h2>Coduri de produse</h2>
      <Col className="text-end">
        <Button className="mb-3" onClick={() => navigate("/bxpart/create")}>
          Adaugă
        </Button>
      </Col>
      {selectable&&<>
        <div className="d-flex gap-2 mb-2">
          <Button type="button" variant="outline-secondary" disabled={!items.length} onClick={()=>setSelected(items.slice(0,50).map(p=>p.id))}>Bifează tot din această pagină</Button>
          <Button type="button" variant="outline-secondary" disabled={!selected.length} onClick={()=>setSelected([])}>Debifează tot</Button>
        </div>
        <WooPublishToolbar ids={selected} onPublished={()=>setSelected([])}/>
      </>}
      <InputGroup className="mb-3">
        <FormControl
          placeholder="Caută după denumire"
          value={search}
          onChange={handleSearchChange}
        />
        {search && (
          <Button variant="outline-danger" onClick={() => setSearchParams({})}>
            Curăță
          </Button>
        )}
      </InputGroup>

      <div className="mb-3">
        <label>
          Rânduri pe pagină:&nbsp;
          <select
            value={itemsPerPage}
            onChange={(e) => {
              setItemsPerPage(parseInt(e.target.value));
              setCurrentPage(0);
            }}
          >
            <option value={5}>5</option>
            <option value={10}>10</option>
            <option value={25}>25</option>
            <option value={50}>50</option>
          </select>
        </label>
      </div>

      <div className="table-responsive">
        <Table striped bordered hover size="sm" className="align-middle">
          <thead className="table-light">
            <tr>
              {selectable&&<th><input type="checkbox" aria-label="Selectează pagina pentru WooCommerce" checked={items.length>0&&items.every(i=>selected.includes(i.id))} onChange={e=>setSelected(prev=>e.target.checked?[...new Set([...prev,...items.map(i=>i.id)])].slice(0,50):prev.filter(id=>!items.some(i=>i.id===id)))}/></th>}
              <th style={{ width: 70 }}>ID</th>
              <th style={{ width: 140 }}>Cod</th>
              <th>Denumire</th>

              <th style={{ width: 90 }}>UM</th>

              <th style={{ minWidth: 260 }}>Grupă produse</th>
              <th style={{ width: 170 }}>Tip grupă</th>

              <th style={{ width: 120 }}>CPV</th>
              <th style={{ width: 120 }}>NC8</th>
              <th style={{ width: 150 }}>EAN</th>

              <th style={{ width: 110 }} className="text-end">
                Kg net
              </th>
              <th style={{ width: 110 }} className="text-end">
                Kg brut
              </th>

              <th
                style={{
                  width: 150,
                  position: "sticky",
                  right: 0,
                  background: "white",
                  zIndex: 2,
                }}
              >
                Acțiuni
              </th>
            </tr>
          </thead>

          <tbody>
            {items.map((it) => {
              const g = it.grupa_produse;
              const u = it.um;
              const grupaLabel = g
                ? `${g.code ?? g.cod ?? ""} • ${g.denumire ?? g.name ?? ""}`.trim()
                : it.grupa_produse_id
                  ? `#${it.grupa_produse_id}`
                  : "—";

              return (
                <tr key={it.id}>
                  {selectable&&<td><input type="checkbox" aria-label={`Selectează ${it.cod} pentru WooCommerce`} checked={selected.includes(it.id)} disabled={!selected.includes(it.id)&&selected.length>=50} onChange={()=>toggle(it.id)}/></td>}
                  <td className="text-muted">{it.id}</td>

                  <td className="fw-semibold">{it.cod}</td>

                  <td style={{ maxWidth: 420 }}>
                    <div className="text-truncate" title={it.denumire || ""}>
                      {it.denumire}
                    </div>
                  </td>

                  <td style={{ maxWidth: 520 }}>
                    <div className="text-truncate" title="Um"></div>
                    {u?.cod ? (
                      <small className="text-muted">{u.cod}</small>
                    ) : null}
                  </td>

                  <td style={{ maxWidth: 520 }}>
                    <div className="text-truncate" title={grupaLabel}>
                      {grupaLabel}
                    </div>
                    {g?.bxvat_cod ? (
                      <small className="text-muted">
                        TVA: {g.bxvat_cod}
                        {g.bxvat_procent != null
                          ? ` (${g.bxvat_procent}%)`
                          : ""}
                      </small>
                    ) : null}
                  </td>

                  <td>
                    <TipGrupaBadge v={it.bxpart_tip_grupa ?? g?.tip_grupa} />
                  </td>

                  <td className="text-muted">{it.cpv || "—"}</td>
                  <td className="text-muted">{it.nc8 || "—"}</td>
                  <td className="text-muted">{it.ean || "—"}</td>

                  <td className="text-end">
                    {it.kg_net != null ? Number(it.kg_net).toFixed(3) : "—"}
                  </td>
                  <td className="text-end">
                    {it.kg_brut != null ? Number(it.kg_brut).toFixed(3) : "—"}
                  </td>

                  <td
                    style={{
                      position: "sticky",
                      right: 0,
                      background: "white",
                      zIndex: 1,
                      whiteSpace: "nowrap",
                    }}
                  >
                    <Button
                      size="sm"
                      variant="primary"
                      onClick={() => navigate(`/bxpart/${it.id}`)}
                    >
                      Editează
                    </Button>{" "}
                    <Button
                      variant="outline-danger"
                      size="sm"
                      onClick={() => handleDelete(it.id)}
                    >
                      Șterge
                    </Button>
                  </td>
                </tr>
              );
            })}
            {(!items || items.length === 0) && (
              <tr>
                <td colSpan={selectable?13:12} className="text-center text-muted py-4">
                  Niciun articol găsit.
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>

      <ReactPaginate
        previousLabel={"← Înapoi"}
        nextLabel={"Înainte →"}
        pageCount={pageCount}
        forcePage={currentPage}
        onPageChange={(event) => setCurrentPage(event.selected)}
        containerClassName={"pagination justify-content-center"}
        pageClassName={"page-item"}
        pageLinkClassName={"page-link"}
        previousClassName={"page-item"}
        previousLinkClassName={"page-link"}
        nextClassName={"page-item"}
        nextLinkClassName={"page-link"}
        activeClassName={"active"}
      />
    </Container>
  );
}

export default BxpartList;
